module.exports = __webpack_public_path__ + "img/microsite-main-page.97fa924b.png";